import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Heart, X, ChevronRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DISMISS_KEY = 'welfareReminderDismissedDate';

export default function WelfareReminderBanner() {
  const [reminder, setReminder] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const dismissedDate = sessionStorage.getItem(DISMISS_KEY);
    const today = new Date().toISOString().slice(0, 10);
    if (dismissedDate === today) {
      setDismissed(true);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/welfare/reminder/today`);
        if (!cancelled && res.data?.show) {
          setReminder(res.data);
        }
      } catch (e) {
        // silent
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const today = new Date().toISOString().slice(0, 10);
    sessionStorage.setItem(DISMISS_KEY, today);
    setDismissed(true);
  };

  if (dismissed || !reminder) return null;

  const isMatchDay = reminder.has_match_today;
  const bg = isMatchDay ? 'from-amber-50 to-rose-50 border-amber-200' : 'from-rose-50 to-rose-50 border-rose-200';
  const iconBg = isMatchDay ? 'bg-amber-500' : 'bg-rose-500';

  return (
    <Link
      to="/welfare"
      className={`block rounded-xl border bg-gradient-to-r ${bg} p-4 hover:shadow-md transition-all relative group`}
      data-testid="welfare-reminder-banner"
    >
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-lg ${iconBg} flex items-center justify-center flex-shrink-0`}>
          <Heart className="w-5 h-5 text-white" strokeWidth={1.75} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-gray-900 text-sm">
            {isMatchDay ? 'Match day check-in' : 'Welfare check-in'}
          </p>
          <p className="text-sm text-gray-700">{reminder.message}</p>
        </div>
        <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-gray-600 group-hover:translate-x-0.5 transition-all flex-shrink-0" />
        <button
          onClick={handleDismiss}
          className="absolute top-2 right-2 p-1 rounded-md text-gray-400 hover:text-gray-700 hover:bg-white/60 transition-colors"
          aria-label="Dismiss for today"
          data-testid="welfare-reminder-dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </Link>
  );
}
